import script from "./SignatureInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureInput.vue?vue&type=script&setup=true&lang=js"

import "./SignatureInput.vue?vue&type=style&index=0&id=1af97688&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af97688"]])

export default __exports__